import dayjs from 'dayjs';
import { Slot, TrackingEvent } from '../../../models/Orders';

export const getDate = (slot: Slot) => {
    return dayjs(slot.startInterval).format('DD/MM/YYYY');
};

export const getWeekDay = (slot: Slot) => {
    return dayjs(slot.startInterval).format('dddd');
};

export const getShortWeekDay = (slot: Slot) => {
    return dayjs(slot.startInterval).format('ddd');
};

export const getIntervalText = (slot: Slot) => {
    return `De ${dayjs(slot.startInterval).format('HH:mm')} a ${dayjs(slot.endInterval).format('HH:mm')}`;
};

export const getConfirmationText = (slot: Slot) => {
    const d = dayjs(slot.startInterval);
    return `${d.format('dddd').charAt(0).toUpperCase() + d.format('dddd').slice(1)} ${d.format('D')} de ${d.format(
        'MMMM',
    )} en el horario de ${d.format('HH:mm')} a ${dayjs(slot.endInterval).format('HH:mm')}`;
};

export const capitalizeFirstLetter = (text: string) => {
    if (text.length === 0) {
        return text;
    }
    return text[0].toUpperCase() + text.slice(1).toLowerCase();
};

export const orderEvents = (events: TrackingEvent[]): TrackingEvent[] => {
    events.sort((a, b) => {
        const dateA = new Date(`${a.date}T${a.time}`);
        const dateB = new Date(`${b.date}T${b.time}`);
        return dateA.getTime() - dateB.getTime();
    });

    return events;
};
